import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { translations } from "@/lib/translations";

const LanguageContext = createContext(null);

function detectInitialLang() {
  try {
    const saved = localStorage.getItem("mgn_lang");
    if (saved === "en" || saved === "fr") return saved;
  } catch {}
  const nav = (typeof navigator !== "undefined" && navigator.language) || "en";
  return nav.toLowerCase().startsWith("fr") ? "fr" : "en";
}

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(detectInitialLang);

  const setLang = (l) => {
    setLangState(l);
    try {
      localStorage.setItem("mgn_lang", l);
    } catch {}
  };

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const value = useMemo(
    () => ({
      lang,
      setLang,
      t: (key) => {
        const hit = key.split(".").reduce((o, k) => (o == null ? o : o[k]), translations[lang]);
        return hit == null ? key : hit;
      },
    }),
    [lang]
  );

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLang() {
  return useContext(LanguageContext);
}
